import React, { useEffect } from 'react';
import { HeroSection } from '../components/HeroSection';
import { AboutSection } from '../components/AboutSection';
import { RentalFormSection } from '../components/RentalFormSection';
import { ProductsSection } from '../components/ProductsSection';
import { ReservationSection } from '../components/ReservationSection';
import { DiscountsSection } from '../components/DiscountsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { StatsSection } from '../components/StatsSection';
import { HotelRentalsSection } from '../components/HotelRentalsSection';
import { CTASection } from '../components/CTASection';
import { RentalFormData, SelectedProduct } from '../App';
interface HomePageProps {
  onSubmitRentalForm: (data: RentalFormData) => void;
  onRentProduct: (product: SelectedProduct) => void;
}
export function HomePage({
  onSubmitRentalForm,
  onRentProduct
}: HomePageProps) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <main className="flex-grow w-full" data-id="element-1048">
      <HeroSection onRentNow={() => onRentProduct({
      name: '3 Wheel or 4 Wheel Heavy-Duty Scooter',
      price: 45,
      image: 'https://cdn.magicpatterns.com/uploads/dD4RgJXfiXfKq35mjPb2H9/scooter-rfwu7jdi9ugdjjqqi1u1fo1vyfphtbhnxy7k3286bk.jpg'
    })} data-id="element-1049" />
      <AboutSection data-id="element-1050" />
      <RentalFormSection onSubmitForm={onSubmitRentalForm} data-id="element-1051" />
      <ProductsSection onRentProduct={onRentProduct} data-id="element-1052" />
      <ReservationSection data-id="element-1053" />
      <DiscountsSection data-id="element-1054" />
      <TestimonialsSection data-id="element-1055" />
      <StatsSection data-id="element-1056" />
      <HotelRentalsSection data-id="element-1057" />
      <CTASection data-id="element-1058" />
    </main>;
}